(() => {
  'use strict';

  const mobile = () => window.matchMedia('(max-width: 749px)').matches;

  const forceThemeColumns = () => {
    if (!mobile()) return;
    document.querySelectorAll('.mb-discovery__body[data-choice-type="themes"] > .mb-discovery__choices').forEach((grid) => {
      grid.style.setProperty('display', 'grid', 'important');
      grid.style.setProperty('grid-template-columns', 'repeat(2, minmax(0, 1fr))', 'important');
      grid.style.setProperty('grid-auto-flow', 'row', 'important');
      grid.querySelectorAll(':scope > .mb-discovery__choice-row').forEach((row) => row.style.setProperty('display', 'contents', 'important'));
    });
  };

  const alignFeaturedArrows = () => {
    if (!mobile()) return;
    document.querySelectorAll('.section-matchboox-home [data-mb40-featured]').forEach((featured) => {
      const active = featured.querySelector('[data-mb40-featured-slide].is-active:not([hidden])') || featured.querySelector('[data-mb40-featured-slide]:not([hidden])');
      const image = active?.querySelector('.mb40__featured-image, .mb40__featured-collage');
      if (!image) return;
      featured.style.setProperty('--mb-v128-featured-arrow-top', `${image.offsetTop + (image.offsetHeight / 2)}px`);
    });
  };

  let queued = false;
  const refresh = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      forceThemeColumns();
      alignFeaturedArrows();
      if (!mobile()) document.querySelectorAll('.mb-v125-maker-arrow').forEach((button) => button.remove());
    });
  };

  const init = () => {
    refresh();
    const observer = new MutationObserver(refresh);
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'data-choice-type'] });
    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('load', refresh, { once: true });
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-mb-discovery-tab], [data-mb40-featured-prev], [data-mb40-featured-next]')) window.setTimeout(refresh, 0);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
